'use strict';

exports.__esModule = true;
exports.internalCreateElement = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isReferentiallyTransparentFunctionComponent = require('./isReferentiallyTransparentFunctionComponent');

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _createElement = function _createElement(hasKey, isReferentiallyTransparent, Component, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    var component = Component;
    if (children) {
      return component(_extends({}, props, { children: children }));
    }
    return component(props);
  }

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

var internalCreateElement = exports.internalCreateElement = function internalCreateElement(Component) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(Component);
  return function (p, c) {
    return _createElement(false, isReferentiallyTransparent, Component, p, c);
  };
};

var createElement = function createElement(Component, props, children) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(Component);
  /* eslint-disable */
  var hasKey = props && props.hasOwnProperty('key');
  /* eslint-enable */
  return _createElement(hasKey, isReferentiallyTransparent, Component, props, children);
};

exports.default = createElement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/recompose/createElement.js
 ** module id = 1024
 ** module chunks = 0
 **/